import { connect } from 'react-redux';
import { streamActions, mediaSelectors } from '@lifesize/nucleus';
import { toggleVideoMuted, toggleAudioMuted, hidePSTN } from 'actions/JoinModal';
import {
  saveAudioMuted,
  saveVideoMuted
} from 'actions/SettingsModal';
import SourceDisplay from 'components/SourceDisplay/JoinSourceDisplay';
import _get from 'lodash/get';

const mapStateToProps = (state, ownProps) => {
  const videoDevices = mediaSelectors.videoDevices(state) || [];
  const audioDevices = mediaSelectors.audioDevices(state) || [];
  const audioOutputDevices = mediaSelectors.audioOutputDevices(state) || [];

  const savedVideoId = _get(state, 'app.avSettings.videoSourceId');
  const savedAudioId = _get(state, 'app.avSettings.audioSourceId');
  let savedVideoDevice;
  let savedAudioDevice;

  if (savedVideoId) {
    savedVideoDevice = videoDevices.find(
      device => (device.deviceId === savedVideoId));
  }

  if (savedAudioId) {
    savedAudioDevice = audioDevices.find(
      device => (device.deviceId === savedAudioId));
  }

  const selectedVideoSource = savedVideoDevice || mediaSelectors.selectedVideoDevice(state);
  const selectedAudioSource = savedAudioDevice || mediaSelectors.selectedAudioDevice(state);
  const selectedAudioOutputDevice = mediaSelectors.selectedAudioOutputDevice(state);
  const primaryVideoSourceId = _get(selectedVideoSource, 'deviceId');
  const primaryAudioSourceId = _get(selectedAudioSource, 'deviceId');

  const defaultVideoSetting = _get(state, 'app.joinModal.isVideoEnabled');
  const defaultAudioSetting = _get(state, 'app.joinModal.isAudioEnabled');

  const selectedSources = {
    primaryVideoSourceId,
    primaryAudioSourceId
  };

  let selectedVideoLabel = selectedVideoSource ? selectedVideoSource.label : null;
  if (!selectedVideoLabel) {
    selectedVideoLabel = videoDevices.length ? videoDevices[0].label : '';
  }

  let selectedAudioLabel = selectedAudioSource ? selectedAudioSource.label : null;
  if (!selectedAudioLabel) {
    selectedAudioLabel = audioDevices.length ? audioDevices[0].label : '';
  }

  let selectedAudioOutputLabel = selectedAudioOutputDevice ? selectedAudioOutputDevice.label : null;
  if (!selectedAudioOutputLabel) {
    selectedAudioOutputLabel = audioOutputDevices.length ? audioOutputDevices[0].label : '';
  }

  const isPSTNAvailable = !!_get(state, 'nucleus.pstnNumbers.length'); // this should be replaced by a more reliable CNUC selector
  const isPSTNVisible = isPSTNAvailable && _get(state, 'app.joinModal.isPSTNVisible');
  const showChooser = isPSTNAvailable && ownProps.singlePageJoin;

  return {
    videoDevices,
    audioDevices,
    selectedSources,
    selectedVideoLabel,
    selectedAudioLabel,
    defaultVideoSetting,
    defaultAudioSetting,
    isPSTNVisible,
    isPSTNAvailable,
    selectedAudioOutputLabel,
    showChooser,
    isAcquiringPrimaryStream: _get(state, 'nucleus.media.isAcquiringPrimaryStream'),
  };
};

const mapDispatchToProps = dispatch => ({
  acquireLocalPrimaryStream: () =>
    dispatch(streamActions.acquireLocalPrimaryStream({ audio: true, video: true })),
  endLocalStream: () => dispatch(streamActions.endLocalStream()),
  selectVideoSource: (id) => {
    dispatch(streamActions.setPrimaryVideoSourceId(id));
    dispatch(streamActions.setSelectedVideoSourceId(id));
    dispatch(streamActions.acquireLocalPrimaryStream({ audio: true, video: true }));
  },
  selectAudioSource: (id) => {
    dispatch(streamActions.setPrimaryAudioSourceId(id));
    dispatch(streamActions.setSelectedAudioSourceId(id));
    dispatch(streamActions.acquireLocalPrimaryStream({ audio: true, video: true }));
  },
  selectAudioOutput: (id) => { dispatch(streamActions.setPrimaryAudioOutputId(id)); },
  setVideoEnabledDefault: (toggle) => {
    dispatch(toggleVideoMuted(toggle));
    dispatch(saveVideoMuted(toggle));
  },
  setAudioEnabledDefault: (toggle) => {
    dispatch(toggleAudioMuted(toggle));
    dispatch(saveAudioMuted(toggle));
  },
  resetPSTNVisibility: () => dispatch(hidePSTN())
});


export default connect(mapStateToProps, mapDispatchToProps)(SourceDisplay);
